import { gql } from "@apollo/client"
import { SNAPCOURSE_QUERY } from "./snapCourseQueries"

export const CREATE_SNAPCOURSE = gql`
    mutation content_createSnapCourse(
      $data: SnapCourseCreateInput!
    ){
        content_createSnapCourse(data:$data){
      ${SNAPCOURSE_QUERY}
      }
    }
`

export const UPDATE_SNAPCOURSE = gql`
    mutation content_updateSnapCourse(
      $data: SnapCourseUpdateInput!
    ){
        content_updateSnapCourse(data:$data){
      ${SNAPCOURSE_QUERY}
      }
    }
`

export const DELETE_SNAPCOURSE = gql`
  mutation content_deleteSnapCourse($data: SnapCourseIdInput!) {
    content_deleteSnapCourse(data: $data)
  }
`
